import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CommunityMediaFeedbackRoute extends DiscourseRoute {
  queryParams = {
    sort: { refreshModel: true },
    status: { refreshModel: true },
    game: { refreshModel: true },
    tag: { refreshModel: true },
    page: { refreshModel: true },
  };

  model({
    sort = "latest",
    status = "all",
    game = "all",
    tag = "",
    page = 0,
  }) {
    return { sort, status, game, tag, page };
  }

  titleToken() {
    return i18n("community_navigation.media_feedback");
  }
}
